/** OpenWeather informa de onde o vento vem. A seta aponta para onde ele vai. */
export function windArrowDegrees(windFromDegrees) {
  const deg = Number(windFromDegrees);
  if (!Number.isFinite(deg)) return 0;
  return (((deg + 180) % 360) + 360) % 360;
}

const FLOW_CARDINALS = ["N", "NE", "L", "SE", "S", "SO", "O", "NO"];

export function windCardinalFromDegrees(degrees) {
  const deg = Number(degrees);
  if (!Number.isFinite(deg)) return "";
  const normalized = ((deg % 360) + 360) % 360;
  return FLOW_CARDINALS[Math.round(normalized / 45) % 8];
}

/** Letra para onde o vento vai — igual à ponta da seta. */
export function windFlowCardinal(windFromDegrees) {
  return windCardinalFromDegrees(windArrowDegrees(windFromDegrees));
}
